/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

// eslint-disable-next-line import/prefer-default-export
export function getPostUrl(post) {
    const { custom_link, is_only_link, post_url } = post;
    if(is_only_link && custom_link){
        return custom_link;
    }
    if(post && post_url){
        let postPath = post_url.split('/');
        let windowPathSplit = window.location.pathname.split('/');
        return [
            windowPathSplit[windowPathSplit.length - 2],
            windowPathSplit[windowPathSplit.length - 1],
            postPath[postPath.length - 1]
        ].join('/');
    }
    return '';
}

export function getRelatedPostUrl(post) {
    if(post && post.post_url){
        let postPath = post.post_url.split('/');
        let windowPathSplit = window.location.pathname.split('/');
        return [
            windowPathSplit[windowPathSplit.length - 3],
            windowPathSplit[windowPathSplit.length - 2],
            postPath[postPath.length - 1]
        ].join('/');
    }
    return '';
}
